import { render, staticRenderFns } from "./StockZone.vue?vue&type=template&id=43f0d1f4"
import script from "./StockZone.vue?vue&type=script&lang=js"
export * from "./StockZone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports